import { render, staticRenderFns } from "./NbSetting.vue?vue&type=template&id=2da25962"
import script from "./NbSetting.vue?vue&type=script&lang=js"
export * from "./NbSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports